import { Button } from '@repo/design-system-cf/components/button'
import { IconShare } from '@repo/design-system-cf/components/icons'
import { tw } from 'utils/classnames'

export function ShareButton({
  onClick,
  size = 'small',
  className,
}: {
  onClick: () => void
  size?: 'small' | 'regular'
  className?: string
}) {
  return (
    <Button
      variant="ghost"
      size={'small'}
      className={tw(
        'text-cf-violet border font-medium border-[#1313151F] flex gap-1 w-auto bg-cf-grey-50 flex-row items-center p-0 !px-2.5 rounded-[40px] hover:bg-cf-grey-200 hover:text-cf-violet',

        size === 'regular' ? 'h-[32px] !px-3 text-16' : 'h-[26px] !px-2.5 text-14',
        className,
      )}
      onClick={onClick}
      iconLeft={<IconShare className={tw(size === 'regular' ? '!size-5' : '!size-4')} />}
      data-testid="share-button"
    >
      {'Share'}
    </Button>
  )
}
